import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Phase 10a.9: Fetch pinned user views for sidebar and view rendering.
 */
export function useUserViews(params?: { pinned_only?: boolean }) {
  return useQuery({
    queryKey: ['user-views', params],
    queryFn: () => api.views.list(params),
    staleTime: 5 * 60 * 1000, // 5 minutes — views rarely change
  });
}

export function useUserView(viewId: string | undefined) {
  return useQuery({
    queryKey: ['user-views', viewId],
    queryFn: () => api.views.get(viewId!),
    enabled: !!viewId,
  });
}
